module.exports = __webpack_public_path__ + "img/01.56eb34d5.png";